module.exports = __webpack_public_path__ + "img/sankaku_43_red.7039a398.png";